<script lang="ts">
    import type {DyResponsePopupTextType} from 'types/dy';

    import Paragraph from 'general/components/description/Paragraph.svelte';

    import s from './style.module.css';

    export let value: DyResponsePopupTextType[] = [];
    export let mobileMargin = '0px';
    export let isSmallerScreen = false;
</script>

<div class="{s.desc} {s.squareDesktopCommon} {s.sms}" style="margin-top: {mobileMargin}">
    {#each value as item}
        {#if item.image}
            <div
                class={s.imgContainer}
                class:smallScreen={isSmallerScreen}
                style="
                    margin: {item.imgMargin || '0 0 32px'};
                    padding: {item.imgPadding || '0 72px'};
                "
            >
                <img
                    src={item.image}
                    alt={item.image}
                    width={item.imgWidth || '116px'}
                    height="62px"
                />

                <Paragraph {item} />
            </div>
        {:else}
            <Paragraph {item} />
        {/if}
    {/each}
</div>
